import { InsurerAddressModel } from './insurer-address.model';
import { PartyTypeCode } from '../consts/party-type-code.enum';

export class InsurerData {

  partyTypeCode?: string;
  pesel?: string;
  lastName?: string;
  firstName?: string;
  address?: InsurerAddressModel;
  birthDate: Date;
  nip?: string;
  companyName?: string;
  drivingLicenseIssueYear?: number;

  constructor() {

    this.partyTypeCode = PartyTypeCode.NATURAL_PERSON;
    this.pesel = null;
    this.lastName = '';
    this.firstName = '';
    this.companyName = null;
    this.nip = null;

    this.address = new InsurerAddressModel();
  }
}
